var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showing)?_c('div',{staticClass:"overlay",on:{"click":function($event){return _vm.close()}}},[_c('div',{staticClass:"alert",on:{"click":function($event){return _vm.close()}}},[_vm._v(" "+_vm._s(_vm.mensaje)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }